import React from "react";
import PropTypes from "prop-types";
import SvgIcon from "@mui/material/SvgIcon";

export default function UnsortedIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M3.36378 1.51953C3.37255 0.967317 3.82731 0.526764 4.37953 0.535529L10.5643 0.633699C11.6691 0.651236 12.5504 1.5614 12.5322 2.66623L12.4346 8.62286C12.4255 9.17507 11.9705 9.61539 11.4183 9.60634C10.8661 9.59728 10.4258 9.14229 10.4349 8.59008L10.5122 3.87214L9.33308 5.05126C9.32673 5.05796 9.32028 5.0646 9.31371 5.07117L4.02264 10.3622L8.62247 10.4353C9.17469 10.444 9.61524 10.8988 9.60648 11.451C9.59771 12.0032 9.14295 12.4438 8.59073 12.435L2.40601 12.3368C1.30117 12.3193 0.419907 11.4091 0.438018 10.3043L0.535668 4.34767C0.544721 3.79546 0.999715 3.35514 1.55193 3.3642C2.10414 3.37325 2.54445 3.82824 2.5354 4.38045L2.45806 9.09839L3.6372 7.91925C3.64354 7.91256 3.64999 7.90593 3.65655 7.89936L8.94763 2.60829L4.34779 2.53528C3.79557 2.52651 3.35502 2.07175 3.36378 1.51953Z" fill="info"/>
    </SvgIcon>
  );
}

UnsortedIcon.propTypes = {
  color: PropTypes.string
};